import { Box, BoxProps, styled, Typography, TypographyProps } from '@mui/material';

import { BRAND_BLUE } from '@/widgets/pricing/pricingCards/lib/constants';

type LabelProps = {
  isActive: boolean;
} & TypographyProps;

export const Label = styled(Typography, { shouldForwardProp: (prop) => prop !== 'isActive' })<LabelProps>(
  ({ isActive, theme }) => ({
    ...theme.typography['body-2-md'],
    color: isActive ? theme.palette.common.white : theme.palette.grey[500],
    whiteSpace: 'nowrap',
  }),
);

type RootContainerProps = {
  isActive: boolean;
} & BoxProps;

export const RootContainer = styled(Box, { shouldForwardProp: (prop) => prop !== 'isActive' })<RootContainerProps>(
  ({ isActive, theme }) => ({
    alignItems: 'center',
    background: isActive ? BRAND_BLUE : 'transparent',
    borderRadius: 360,
    boxShadow: isActive ? theme.customShadows.sm : 'none',
    boxSizing: 'border-box',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    padding: '8px 12px',
    textAlign: 'center',
    width: 120,
    '&:focus-visible': {
      outline: `2px solid ${theme.palette.primary[600]}`,
      outlineOffset: 2,
    },
  }),
);
